import React from "react";
import "./Courses.css";

import ApplicationForm from "../images/ApplicationForm.pdf";

const CourseDetails = [
  {
    id: 1,
    name: "Certificate in Information Technology Application (CITA)",
    duaration: "6",
    qualification: "Madhyamik or Equivalent Appeared or Higher",
    fees: "₹ 2,000 (₹ 500 + ₹300 X 5 Months)",
    content:
      "Fundamentals of Computer, Operating System - Windows-7 & Windows-10, MS-Office (Word, Excel & PowerPoint)",
  },
  {
    id: 2,
    name: "Diploma in Information Technology Application (DITA)",
    duaration: "12",
    qualification: "Madhyamik or Equivalent Appeared or Higher",
    fees: "₹ 2,000 + ₹ 2,000 = ₹ 4,000, Fees to be paid for during the 2nd Semester is ₹ 2,000 (₹ 500 X 4 Months)",
    content:
      "Programming Concepts Algorithm & Flow chart, Visual Basic, RDBMS concepts with MS-Access, Project on Visual Basic & MS-Access, Internet & E-Mail Overview of VB.Net",
  },
  {
    id: 3,
    name: "Certificate in Computer Aided Design (CCAD)",
    duaration: "6",
    qualification: "Polytechnic student or Diploma in Engineering student",
    fees: "₹ 5,000 (₹ 2,000 + ₹500 X 6 Months)",
    content:
      "Fundamentals of Computer, Operating System - Windows-7 & Windows-10, MS-Word,AUTOCAD, Internet & E-Mail",
  },
  {
    id: 4,
    name: "Certificate in Financial Accounting System (CFAS)",
    duaration: "6",
    qualification: "Madhyamik or Equivalent Appeared or Higher",
    fees: "₹ 2,000 (₹ 600 + ₹ 350 X 4 Months)",
    content:
      "Fundamentals of Computer, Operating System - Windows Vista / XP, Ms-Word, Two Financial Accounting Package",
  },
  {
    id: 5,
    name: "Certificate in Desktop Publishing (CDTP)",
    duaration: "6",
    qualification: "Madhyamik or Equivalent Appeared or Higher",
    fees: "₹ 2,000 (₹ 600 + ₹ 350 X 4 Months)",
    content:
      "Fundamentals of Computer, Operating System - Windows Vista, Ms-Word, Adobe PageMaker, CoralDRAW, Use of Bengali Fonts in Publication",
  },
  {
    id: 6,
    name: "Certificate in Web Designing (CWD)",
    duaration: "6",
    qualification:
      "10+2 Passed or Appeared or Diploma in Engineering or Higher",
    fees: "₹ 3,500 (₹ 1,100 + ₹ 600 X 4 Months)",
    content:
      "Concepts on Internate, Protocols, Browers, Domain names & registering domain name, HTML, CSS, JavaScript, Project on Web Designing",
  },
];

const Courses = () => {
  return (
    <div className="courses">
      <div className="course">
        <span>Course Details</span>
        <h5>Certification Course - </h5>
        <div className="form-fillup-link">
          <a
            className="form-fill-up"
            href={ApplicationForm}
            download={"Application Form"}
          >
            Download Appliation form
          </a>
          <a
            className="form-fill-up online"
            href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
            target="_blank"
          >
            Online Form Fill Up
          </a>
        </div>

        <div className="course-details">
          {CourseDetails &&
            CourseDetails.map((cd) => (
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdde1RPeGuya6eg4HDVhfsUG5ul9BmbJB9nQUhBJu3dA9v72g/viewform"
                target="_blank"
              >
                <div className="cd-details">
                  <h4 className="title">{cd.name}</h4>
                  <p className="duaration">
                    <span>Duaration:</span> {cd.duaration} Months
                  </p>
                  <p className="desc-content">
                    <span>Content:</span> {cd.content}
                  </p>
                  <p className="eligibility">
                    <span>Eligibility:</span> {cd.qualification}
                  </p>
                  <p className="fees">
                    <span>Course Fees:</span> {cd.fees}
                  </p>
                </div>
              </a>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Courses;
